class FeaturedCollections extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-featured-collections-slider')
    const prevEl = this.querySelector('.featured-collections--icon-previous')
    const nextEl = this.querySelector('.featured-collections--icon-next')
    const option = {
      init: false,
      spaceBetween: 10,
      slidesPerView: 2.6648,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 2,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.8,
          slidesPerGroup: 2,
        },
        990: {
          spaceBetween: 20,
          slidesPerView: 3.8,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 3,
        },
        1200: {
          spaceBetween: 20,
          slidesPerView: 4.8,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          slidesPerGroup: 4,
        },
        1400: {
          slidesPerView: 6.567,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          spaceBetween: 20,
          slidesPerGroup: 6,
        },
        1800: {
          slidesPerView: 7.5,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
          spaceBetween: 20,
          slidesPerGroup: 7,
        }
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.init()

    this.$swiper.on('click', (swiper, event) => {
      const cardObj = event.target.closest('.featured-collections__card')
      if(cardObj) {
        const url = cardObj.dataset.href
        this.updateContent(url)
      }
    })
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }

  async updateContent(url) {
    window.history.replaceState({}, '', url)
    try {
      const response = await fetch(url)
      const text = await response.text()
      const html = new DOMParser().parseFromString(text, 'text/html')
      const content = html.querySelector('main').innerHTML
      const $mainContainer = document.querySelector('main')
      if ($mainContainer) {
        $mainContainer.innerHTML = content
      }
    } catch (error) {
      console.error('Error:', error.message)
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: for a smooth scrolling animation
    });
  }
}

if (typeof customElements.get('featured-collections') === 'undefined') {
  customElements.define('featured-collections', FeaturedCollections)
}
